import { TabConfig } from "components/navigation/Tabs/useConfigTabs";
import PaymentDetails from "../PaymentDetails";
import { PaymentScheduleTable } from "../PaymentScheduleTable";

export const contractBillingTabsConfig: TabConfig[] = [
  {
    id: 1,
    label: 'Echeancier',
    content: <PaymentScheduleTable />
  },
  {
    id: 2,
    label: 'Paiement',
    content: <PaymentDetails />
  },

  {
    id: 3,
    label: 'Factures',
    content: <PaymentScheduleTable />
  },
];
